<template>
  <nav class="navbar is-link" role="navigation" aria-label="main navigation">
    <div class="navbar-brand" id="navMenu">
      <a id="acv" class="navbar-item" href="#">ACV</a>
      <a id="navHome" class="navbar-item is-active" href="#/">Home</a>
      <a id="navAbout" class="navbar-item" href="#/about">About</a>
      <a id="navMethodology" class="navbar-item" href="#/methodology">Methodology</a>
      <div id="dropdownParent" class="navbar-item has-dropdown is-hoverable">
        <a id="navAboutUs" class="navbar-link">
          About Us
        </a>
        <div id="navDropdown" class="navbar-dropdown">
          <a id="navResearchers" class="navbar-item" href="#/researchers">
            Researchers
          </a>
          <a id="navArtist" class="navbar-item" href="#/artist">
            Artist
          </a>
          <a id="navAnimator" class="navbar-item" href="#/animator">
            Animator
          </a>
        </div>
      </div>
      <a class="navbar-item" href="#/contactus">Contact Us</a>

      <a role="button" class="navbar-burger" data-target="navMenu" aria-label="menu" aria-expanded="false">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
      </div>
  </nav>
</template>

<script>
document.addEventListener('DOMContentLoaded', () => {
  const $navbarItems = Array.prototype.slice.call(document.querySelectorAll('.navbar-item'), 0)

  if ($navbarItems.length > 0) {
    $navbarItems.forEach(el => {
      el.addEventListener('click', () => {
        if (el.id !== 'dropdownParent') {
          $navbarItems.forEach(el2 => {
            el2.classList.remove('is-active')
          })
          var dropdownParent = document.getElementById('navAboutUs')
          dropdownParent.classList.remove('is-active')

          if (el.parentElement.id !== 'navDropdown') {
            el.classList.toggle('is-active')
          } else {
            dropdownParent.classList.add('is-active')
          }
        }
      })
    })
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue